<template>
  <div class="container">
    <div class="row row-cards">
       <div class="col-12">
        <div class="row">
          <div class="col-sm-6">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Estimated Income</div>
                <div class="display-4 font-weight-bold mb-4">S${{income.estimated | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-green" :style="'width: 100%'"></div>
                </div>
              </div>
            </div>
          </div>
           <div class="col-sm-6">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Actual Income</div>
                <div class="display-4 font-weight-bold mb-4">S${{income.actual | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-green" :style="'width: 100%'"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Estimated Expenses</div>
                <div class="display-4 font-weight-bold mb-4">S${{expense.estimated | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-orange" :style="'width: 100%'"></div>
                </div>
              </div>
            </div>
          </div>
           <div class="col-sm-6">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Actual Expenses</div>
                <div class="display-4 font-weight-bold mb-4">S${{expense.actual | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-orange" :style="'width: 100%'"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Estimated Profit</div>
                <div class="display-4 font-weight-bold mb-4">S${{profit.estimated | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-blue" style="width: 100%"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card">
              <div class="card-body text-center">
                <div class="h5">Actual Profit</div>
                <div class="display-4 font-weight-bold mb-4">S${{profit.actual | currency}}</div>
                <div class="progress progress-sm">
                  <div class="progress-bar bg-blue" style="width: 100%"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  },
  computed: {
    income () {
      return this.$store.getters['income/getTotal']
    },
    expense () {
      return this.$store.getters['expense/getTotal']
    },
    profit () {
      let income = this.$store.getters['income/getTotal']
      let expense = this.$store.getters['expense/getTotal']
      return {
        estimated: income.estimated - expense.estimated,
        actual: income.actual - expense.actual
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue